<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-box"></i> 固定物资</span>
      </div>

      <!-- 搜索区域 -->
      <el-form
        :model="queryParams"
        label-position="right"
        label-width="70px"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="物资名称">
              <el-input
                v-model="queryParams.key_word"
                placeholder="请输入物资名称"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 按钮区域 -->
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="openAddMaterialDialog"
          >
            新增物资
          </el-button>
          <el-button
            type="success"
            icon="el-icon-search"
            @click="handleQuery"
          >
            搜索
          </el-button>
        </div>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column
          prop="assetsCatName"
          label="物资类别"
          width="200"
          fixed
        ></el-table-column>
        <el-table-column
          prop="fixedAssetsName"
          label="物资名称"
          width="200"
          fixed
        ></el-table-column>
        <el-table-column
          prop="providerName"
          label="供应商"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="assetsCode"
          label="资产二维码"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="nationalAssetsCode"
          label="国有资产码"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="storageLocation"
          label="存放位置"
        ></el-table-column>
        <el-table-column
          prop="dutyPersonName"
          label="归属人"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="dutyDeptName"
          label="归属部门"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="assetsUnit"
          label="单位"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="expireDate"
          label="过期时间"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="creatorName"
          label="创建人"
          width="150"
        ></el-table-column>
        <!-- 操作列 -->
        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="openScrapDialog(scope.row)"
              type="danger"
              style="margin-right: 10px"
              >报废出库</el-button
            >
            <el-button
              size="mini"
              @click="openEditDialog(scope.row)"
              type="primary"
              style="margin-right: 10px"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="handleDelete(scope.row)"
              type="warning"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 新增/编辑物资弹窗 -->
      <el-dialog
        :title="isEdit ? '编辑物资' : '新增物资'"
        :visible.sync="materialDialogVisible"
        width="600px"
        @close="resetMaterialForm"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="materialForm"
          :rules="materialRules"
          ref="materialFormRef"
          label-width="100px"
        >
          <el-form-item label="物资类别" prop="assetsCatCode">
            <el-select
              v-model="materialForm.assetsCatCode"
              placeholder="请选择物资类别"
              style="width: 400px"
              @change="handleCategoryChange"
            >
              <el-option
                v-for="item in categoryOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="物资名称" prop="fixedAssetsName">
            <el-input
              v-model="materialForm.fixedAssetsName"
              placeholder="请输入物资名称"
              style="width: 400px"
            />
          </el-form-item>
          <el-form-item label="供应商" prop="providerCode">
            <el-select
              v-model="materialForm.providerCode"
              placeholder="请选择供应商"
              style="width: 400px"
              @change="handleProviderChange"
            >
              <el-option
                v-for="item in supplierList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="绑定二维码" prop="assetsCode">
            <el-select
              v-model="materialForm.assetsCode"
              placeholder="请选择资产二维码"
              style="width: 400px"
            >
              <el-option
                v-for="item in assetCodeList"
                :key="item.serialNo"
                :label="item.serialNo"
                :value="item.serialNo"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="国有资产码" prop="nationalAssetsCode">
            <el-input
              v-model="materialForm.nationalAssetsCode"
              placeholder="请输入国有资产码"
              style="width: 400px"
            />
          </el-form-item>
          <el-form-item label="存放位置" prop="storageLocation">
            <el-input
              v-model="materialForm.storageLocation"
              placeholder="请输入存放位置"
              style="width: 400px"
            />
          </el-form-item>

          <el-form-item label="归属人" prop="dutyPersonCode">
            <el-select
              v-model="materialForm.dutyPersonCode"
              placeholder="请选择归属人"
              style="width: 400px"
              @change="handleDutyPersonChange"
              filterable
              :filter-method="filterUser"
            >
              <el-option
                v-for="item in filteredUsers"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="归属部门" prop="dutyDeptName">
            <el-input
              v-model="materialForm.dutyDeptName"
              disabled
              placeholder="请输入归属部门"
              style="width: 400px"
            />
          </el-form-item>
          <el-form-item label="单位" prop="assetsUnit">
            <el-input
              v-model="materialForm.assetsUnit"
              placeholder="请输入单位"
              style="width: 400px"
            />
          </el-form-item>
          <el-form-item label="过期时间" prop="expireDate">
            <el-date-picker
              v-model="materialForm.expireDate"
              type="datetime"
              placeholder="选择日期"
              style="width: 400px"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="datePickerOptions"
            />
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="materialForm.remark"
              placeholder="请输入备注"
              style="width: 400px"
            />
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="materialDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveMaterial">保存</el-button>
        </div>
      </el-dialog>

      <!-- 报废出库弹窗 -->
      <el-dialog
        title="报废出库"
        :visible.sync="scrapDialogVisible"
        width="600px"
        @close="resetScrapForm"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="scrapForm"
          :rules="scrapRules"
          ref="scrapFormRef"
          label-width="100px"
        >
          <el-form-item label="物资名称" prop="name">
            <el-input
              disabled
              v-model="scrapForm.name"
              placeholder="请输入物资名称"
              style="width: 400px"
            />
          </el-form-item>
          <el-form-item label="国有资产码" prop="nationalAssetsCode">
            <el-input
              v-model="scrapForm.nationalAssetsCode"
              disabled
              style="width: 400px"
            />
          </el-form-item>
          <el-form-item label="报废缘由" prop="remark">
            <el-input v-model="scrapForm.remark" style="width: 400px" />
          </el-form-item>
          <el-form-item label="附件上传" prop="images">
            <el-upload
              :headers="uploadHeaders"
              :action="UPLOAD_URL"
              list-type="picture-card"
              :file-list="scrapForm.images"
              :on-remove="handleImageRemove"
              :on-success="handleImageSuccess"
              :on-exceed="handleExceed"
              :limit="2"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="scrapDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitScrap">提交</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { MAX_PAGE_SIZE, FIXED_NAME, UPLOAD_URL } from "@/utils/const";
import { staffList } from "@/api/staff";
import {
  getFixedAssetsInfoList,
  addNewFixedAssets,
  updateFixedAssets,
  deleteFixedAssets,
  assetsCategoryPage,
  getAllApproveSteps,
  scrapOutStock,
} from "@/api/material";
import { qrcodePage } from "@/api/config";
import PaginationBar from "@/components/PaginationBar";
import { getToken } from "@/utils/auth";
import { mapState } from "vuex";

export default {
  components: { PaginationBar },
  computed: {
    ...mapState(["supplierList"]), // 从 Vuex 获取 userPermissions
  },
  data() {
    return {
      uploadHeaders: {
        token: getToken(), // 替换为你的 token
      },
      UPLOAD_URL,
      datePickerOptions: {
        disabledDate(time) {
          // 禁用今天之前的日期
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },

      tableData: [],
      queryParams: {
        key_word: "",
      },
      categoryOptions: [],
      assetCodeList: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      materialDialogVisible: false,
      isEdit: false,
      fixedAssetsId: "",
      materialForm: {
        assetsCatCode: "",
        fixedAssetsName: "",
        providerCode: "", //供应商的code
        assetsCode: "",
        nationalAssetsCode: "",
        storageLocation: "",
        dutyPersonCode: "",
        dutyDeptName: "",
        assetsUnit: "",
        expireDate: "",
        remark: "",
      },
      dutyPersonName: "", // 用户名
      dutyDeptCode: "", // 部门id
      // assetsCatCode: "", //分类的code
      assetsCatName: "",
      providerName: "",
      // providerCode: "", //供应商的code
      materialRules: {
        assetsCatCode: [
          { required: true, message: "请选择物资类别", trigger: "change" },
        ],
        fixedAssetsName: [
          { required: true, message: "请输入物资名称", trigger: "blur" },
        ],
        providerCode: [
          { required: false, message: "请选择供应商", trigger: "change" },
        ],
        assetsCode: [
          { required: true, message: "请输入关联资码", trigger: "blur" },
        ],
        nationalAssetsCode: [
          { required: true, message: "请输入国有资产编码", trigger: "blur" },
        ],
        storageLocation: [
          { required: true, message: "请输入存放位置", trigger: "blur" },
        ],
        dutyPersonCode: [
          { required: true, message: "请选择归属人", trigger: "change" },
        ],
        dutyDeptName: [
          { required: true, message: "请输入归属部门", trigger: "blur" },
        ],
        assetsUnit: [
          { required: true, message: "请输入单位", trigger: "blur" },
        ],
        expireDate: [
          { required: true, message: "请选择过期时间", trigger: "change" },
        ],
      },
      userOptions: [], //员工信息
      filteredUsers: [],
      scrapDialogVisible: false,
      scrapForm: {
        fixedAssetsName: "",
        nationalAssetsCode: "",
        remark: "",
        fixedAssetsId: "", //提交的数据
        images: [],
      },
      approveStepList: [], //报废审批流程
      imagesUrl: [], // 保存上传的图片 URL
      creator: "", //
      creatorName: "", //提交数据
      scrapRules: {
        fixedAssetsName: [
          { required: true, message: "请输入物资名称", trigger: "change" },
        ],
        nationalAssetsCode: [
          { required: true, message: "国有资产码不能为空", trigger: "blur" },
        ],
        remark: [
          { required: true, message: "请输入报废缘由", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.handleQuery();
    // 请求所有的固定物资
    this.getAllFixed();
    // 请求所有的供应商
    // this.getSupplierList();
    // 请求所有的员工getAllCode
    this.getStaffList();
    // 请求所有的部门
  },
  // mounted() {
  //   this.filteredUsers = this.userOptions; // 初始化显示全部
  // },
  methods: {
    filterUser(query) {
      if (!query) {
        this.filteredUsers = this.userOptions;
        return;
      }
      this.filteredUsers = this.userOptions.filter((item) =>
        item.name.toLowerCase().includes(query.toLowerCase())
      );
    },

    // 请求所有的未使用的二维码 /qrcode/page
    getAllCode() {
      qrcodePage({
        pageNo: 1,
        pageSize: MAX_PAGE_SIZE,
      }).then((res) => {
        // 需要过滤到state：0的
        this.assetCodeList = res.records.filter(
          (item) => parseInt(item.state) === 0
        );
      });
    },
    getApprove() {
      getAllApproveSteps({
        approvalTypeId: "1925821693023293441", // 固定物资 报废
      }).then((res) => {
        this.approveStepList = res || [];
      });
    },
    // 新增物资的清空
    resetMaterialForm() {
      this.$refs.materialFormRef.resetFields();
    },
    // 报废的清空
    resetScrapForm() {
      this.$refs.scrapFormRef.resetFields();
    },
    handleExceed() {
      this.$message.warning(`超出最大上传数量`);
    },
    handleProviderChange(value) {
      const selectedSupplier = this.supplierList.find(
        (item) => item.id === value
      );
      if (selectedSupplier) {
        // 供应商名称
        this.providerName = selectedSupplier.name;
      }
    },
    handleCategoryChange(value) {
      const selectedCategory = this.categoryOptions.find(
        (item) => item.id === value
      );
      if (selectedCategory) {
        // 分类名称
        this.assetsCatName = selectedCategory.name;
      }
    },
    handleDutyPersonChange(value) {
      // 可以在这里执行其他逻辑，例如根据归属人查询所属部门、更新表单等
      const selectedUser = this.userOptions.find((user) => user.id === value);
      // 还要处理ID
      if (selectedUser) {
        this.dutyPersonName = selectedUser.name; // 用户id
        this.dutyDeptCode = selectedUser.departmentId; // 部门
        // 假设要自动填充归属部门
        this.materialForm.dutyDeptName = selectedUser.departmentName;
      }
    },
    // 请求所有的职工信息
    getStaffList() {
      const params = {
        pageNo: 1,
        pageSize: MAX_PAGE_SIZE,
      };
      staffList(params)
        .then((res) => {
          // 设置list
          this.filteredUsers = this.userOptions = res.records;
        })
        .catch((err) => {
          console.error("请求失败：", err);
        });
    },
    getAllFixed() {
      assetsCategoryPage({
        pageNo: 1,
        pageSize: MAX_PAGE_SIZE,
        category: FIXED_NAME, //
      }).then((res) => {
        this.categoryOptions = res.records;
      });
    },

    // 处理图片移除
    handleImageRemove(file, fileList, index) {
      this.scrapForm.images = fileList;
      // 文件移除后更新表单的图片数组
      this.imagesUrl.splice(index, 1);
    },
    // 处理图片变化（上传新图片时）
    handleImageSuccess(data, file) {
      console.log("Changed file:", data);
      if (data.code === 0) {
        // 上传成功
        // this.imagesUrl = data.data;
        this.imagesUrl.push(data.data);
      }
      this.scrapForm.images.push(file);
    },
    handleQuery(page) {
      // 确保page是数字类型
      if (typeof page === 'number') {
        this.currentPage = page;
      } else {
        // 从搜索按钮调用时，保持当前页码
        this.currentPage = this.currentPage || 1;
      }
      // 确保参数名称与API要求一致
      const params = {
        page_no: this.currentPage,
        page_size: this.pageSize,
        key_word: this.queryParams.key_word || ""
      };
      console.log('搜索参数:', params);
      getFixedAssetsInfoList(params).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    openAddMaterialDialog() {
      this.isEdit = false;
      this.fixedAssetsId = "";
      this.materialDialogVisible = true;
      this.getAllCode();
    },
    openEditDialog(row) {
      this.isEdit = true;
      this.fixedAssetsId = row.fixedAssetsId;
      // 填充表单数据
      this.materialForm = {
        assetsCatCode: row.assetsCatCode,
        fixedAssetsName: row.fixedAssetsName,
        providerCode: row.providerCode,
        assetsCode: row.assetsCode,
        nationalAssetsCode: row.nationalAssetsCode,
        storageLocation: row.storageLocation,
        dutyPersonCode: row.dutyPersonCode,
        dutyDeptName: row.dutyDeptName,
        assetsUnit: row.assetsUnit,
        expireDate: row.expireDate,
        remark: row.remark,
      };
      // 填充其他相关数据
      this.dutyPersonName = row.dutyPersonName;
      this.dutyDeptCode = row.dutyDeptCode;
      this.assetsCatName = row.assetsCatName;
      this.providerName = row.providerName;
      this.materialDialogVisible = true;
      // 编辑时不需要获取新的二维码，因为资产已经绑定了二维码
    },
    handleDelete(row) {
      this.$confirm('确定要删除这条固定物资吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用删除接口
        deleteFixedAssets({
          fixedAssetsId: row.fixedAssetsId
        }).then((res) => {
          this.$message.success('删除成功');
          this.handleQuery();
        });
      }).catch(() => {
        // 取消删除
      });
    },
    saveMaterial() {
      this.$refs.materialFormRef.validate((valid) => {
        if (!valid) return;
        // 参数提交
        const params = {
          dutyPersonName: this.dutyPersonName, // 用户名
          dutyDeptCode: this.dutyDeptCode, // 部门id
          assetsCatName: this.assetsCatName, //分类的名称
          providerName: this.providerName, //供应商的名称
          ...this.materialForm,
        };

        if (this.isEdit) {
          // 编辑模式
          params.fixedAssetsId = this.fixedAssetsId;
          updateFixedAssets(params).then((res) => {
            this.$message.success("编辑成功");
            this.materialDialogVisible = false; // 关闭弹窗
            this.handleQuery();
          });
        } else {
          // 新增模式
          addNewFixedAssets([params]).then((res) => {
            this.$message.success("保存成功");
            this.materialDialogVisible = false; // 关闭弹窗
            this.handleQuery();
          });
        }
      });
    },
    openScrapDialog(row) {
      console.log(row);
      this.scrapForm.name = row.fixedAssetsName;
      this.scrapForm.fixedAssetsId = row.fixedAssetsId;
      this.scrapForm.nationalAssetsCode = row.nationalAssetsCode;
      this.scrapDialogVisible = true;
      this.creator = row.creator;
      this.creatorName = row.creatorName;
      this.getApprove();
      // console.log("scrapForm", this.scrapForm);
    },
    // 请求审批流程
    submitScrap() {
      this.$refs.scrapFormRef.validate((valid) => {
        if (!valid) return;
        let scrapParams = {};
        scrapParams.fixedAssetsId = this.scrapForm.fixedAssetsId;
        scrapParams.remark = this.scrapForm.remark;
        scrapParams.approveStepList = this.approveStepList;
        scrapParams.creator = this.creator;
        scrapParams.creatorName = this.creatorName;
        scrapParams.imgList = this.imagesUrl.map((item) => {
          return {
            imgUrl: item,
          };
        });
        // console.log("提交报废:", scrapParams, this.scrapForm, this.imagesUrl);
        scrapOutStock(scrapParams).then((res) => {
          this.scrapDialogVisible = false;
          this.$message.success("操作成功");
          this.handleQuery();
        });
      });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
